/**
 * 企画回別商品一覧画面のサイクル情報保存クラス
 *
 * @export SaveCycleInfo
 * @class SaveCycleInfo
 */
export class SaveCycleInfo {
  constructor(
    public cycleInfoList: CycleInfoList[],
    public cycleDecisionFlg: string,
  ) {}
}

export class CycleInfoList {
  constructor(
    public orderCode: string,
    public mediumType: string,
    public pcode: string,
    public itemCode: string,
    public specialFeature: string,
    public folio: string,
    public edlp: string,
    public rememberGoods: string,
    public buyerComment: string,
    public coopFlg142: boolean,
    public coopFlg163: boolean,
    public coopFlg185: boolean,
    public coopFlg240: boolean,
    public coopFlg210: boolean,
    public coopFlg302: boolean,
    public coopFlg515: boolean,
    public coopFlg451: boolean,
    public pricePattern: string,
    public pricePromotion: string,
    public bargainMarkFlg: string,
    public komaPromotion: string,
    public promotionMark: string,
    public appearDiv: string,
    public orderNumQuotaCode: string,
    public mediumWPublishFlg: string,
    public crossDecisionFlg: string,
    public wCrossFlg: string,
    public thisTimeSupplyPrice: string,
    public thisTimeCostPrice: string,
    public planNum: string
  ) {}
}
